import { render } from "./TicketDetail.vue?vue&type=template&id=071df49b&scoped=true&ts=true"
import script from "./TicketDetail.vue?vue&type=script&lang=ts"
export * from "./TicketDetail.vue?vue&type=script&lang=ts"

import "./TicketDetail.vue?vue&type=style&index=0&id=071df49b&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071df49b"]])

export default __exports__